import React, { useEffect, useRef } from "react";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import clsx from "clsx";
import { Button, Form, MenuItem, SelectField, TextField } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { isEmpty, isEqual, isFunction, refIsRequiredError } from "@util/utils";

import useSwitch from "@util/hook/useSwitch";

const ProteinPushDialog = React.forwardRef((props, ref) => {
	const { className, open, sourceData, onClose, refresh } = props;
    if (!open) return null;
	const { memberID, proteinPush = {}, pushStatusOptions, pushReasonTypeOptions } = sourceData || {};
	const { postMemberProfileProteinPushApi } = useMemberProfileApi();

	const { isOn: isShow, handleTurnOn, handleTurnOff } = useSwitch();

	const pushStatusRef = useRef(null);
	const reasonTypeRef = useRef(null);
	const reasonTextRef = useRef(null);

	const doMemberProfileProteinPushApi = async (memberID, params) => {
		let resp = await postMemberProfileProteinPushApi(memberID, params);
		if (resp) {
			const { pushStatus, pushStatusText, reasonType, reasonTypeText, reasonText } = resp;

			isFunction(refresh) &&
				refresh({
					pushStatus,
					pushStatusText,
					reasonType,
					reasonTypeText,
					reasonText,
				});
			isFunction(onClose) && onClose();
		}
	};

	const handleSubmit = () => {
		const isError = refIsRequiredError(pushStatusRef, reasonTypeRef, reasonTextRef);
		if (!isError) {
			const params = {
				pushStatus: (pushStatusRef.current && pushStatusRef.current.getResult()) || 0,
				reasonType: (reasonTypeRef.current && reasonTypeRef.current.getResult()) || 0,
				reasonText: (reasonTextRef.current && reasonTextRef.current.getResult()) || "",
			};
			doMemberProfileProteinPushApi(memberID, params);
		}
	};

	const handleReasonTypeChange = e => {
		let val = e.target.value;
		if (isEqual(val, "99") && !isShow) {
			handleTurnOn();
		} else if (isShow) {
			handleTurnOff();
		}
	};

	useEffect(
		() => {
			if (open) {
				isEqual(proteinPush?.reasonType, "99") && handleTurnOn();
			}
		},
		// eslint-disable-next-line
		[open]
	);

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>蛋白訂單</GradientColorHeader>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<SelectField label="訂單狀態" ref={pushStatusRef} key={proteinPush?.pushStatus} defaultValue={proteinPush?.pushStatus} displayEmpty fullWidth required>
							{!isEmpty(pushStatusOptions) &&
								pushStatusOptions.map(item => (
									<MenuItem key={item.value} value={item.value}>
										{item.text}
									</MenuItem>
								))}
						</SelectField>
					</Grid>
					<Grid item xs={6}>
						<SelectField
							label="原因"
							ref={reasonTypeRef}
							key={proteinPush?.reasonType}
							defaultValue={proteinPush?.reasonType}
							onChange={handleReasonTypeChange}
							displayEmpty
							fullWidth
							required
						>
							{!isEmpty(pushReasonTypeOptions) &&
								pushReasonTypeOptions.map(item => (
									<MenuItem key={item.value} value={item.value}>
										{item.text}
									</MenuItem>
								))}
						</SelectField>
					</Grid>
					{isShow && (
						<Grid item xs={12}>
							<TextField
								label="其他原因"
								ref={reasonTextRef}
								key={proteinPush?.reasonText}
								defaultValue={proteinPush?.reasonText}
								InputProps={{ placeholder: "請輸入" }}
								rows="4"
								multiline
								fullWidth
							/>
						</Grid>
					)}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default ProteinPushDialog;
